import { type BaseErrorOptions, createErrorClass } from '@canvas/error';

export class AtlassianClientFetchError extends createErrorClass(
  'AtlassianClientFetchError',
) {
  constructor(
    readonly errorCode: number,
    readonly reason: string,
    readonly body?: string,
    options?: BaseErrorOptions,
    metaData?: Record<string, string>,
  ) {
    super(
      `Failed to fetch JSON response in AtlassianClient: ${errorCode}; ${reason}; ${body}, ${JSON.stringify(
        metaData,
      )}`,
      options,
    );
  }
}
